import React, { useEffect } from "react";
import HomeNavBar from "../Comps/HOME/HomeNavBar";
import HomeSuggestion from "../Comps/HOME/HomeSuggestion";
import StrokeTextAnimation from "../Comps/Extra/StrokeAnimation";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="  ">
      {/* ================= HERO SECTION ================= */}

      <section className="px-2 px-md-3 py-3">
        <div
          className="position-relative overflow-hidden rounded-4 shadow"
          style={{
            background: "#fff",
            minHeight: "190px",
          }}
        >
          {/* ================= TOP GRADIENT ================= */}
          <div
            className="position-absolute top-0 start-0 w-100"
            style={{
              height: "100%",
              background:
                "linear-gradient(120deg, #063b87 0%, #0a57bb 45%, #087344 100%)",
            }}
          />

          {/* Decorative glow */}
          <div
            className="position-absolute"
            style={{
              width: "280px",
              height: "280px",
              borderRadius: "50%",
              right: "-100px",
              top: "-160px",
              background: "rgba(255,255,255,0.10)",
              filter: "blur(2px)",
            }}
          />

          <div
            className="position-absolute"
            style={{
              width: "180px",
              height: "180px",
              borderRadius: "50%",
              left: "-80px",
              top: "-100px",
              background: "rgba(255,255,255,0.06)",
            }}
          />

          {/* ================= RAILWAY LINE DECORATION ================= */}
          <div
            className="position-absolute d-none d-md-block"
            style={{
              right: "30px",
              top: "20px",
              width: "220px",
              height: "60px",
              opacity: 0.18,
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "2px",
                background: "#fff",
                top: "18px",
                transform: "rotate(-8deg)",
              }}
            />

            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "2px",
                background: "#fff",
                top: "38px",
                transform: "rotate(-8deg)",
              }}
            />

            {[20, 65, 110, 155, 200].map((left) => (
              <div
                key={left}
                style={{
                  position: "absolute",
                  width: "3px",
                  height: "32px",
                  background: "#fff",
                  left: `${left}px`,
                  top: "12px",
                  transform: "rotate(-8deg)",
                }}
              />
            ))}
          </div>

          {/* ================= CONTENT ================= */}
          <div
            className="position-relative d-flex flex-column align-items-center justify-content-center text-center"
            style={{
              minHeight: "190px",
              zIndex: 2,
            }}
          >
            {/* Brand */}
            <div
              className="fw-bold"
              style={{
                width: "min(520px, 85%)",
                marginTop: "-4px",
              }}
            >
              <StrokeTextAnimation text="Rail - Setu" />
            </div>

            {/* Subtitle */}
            <div
              className="mt-1 px-2"
              style={{
                color: "#f4f7fb",
                fontSize: "clamp(0.72rem, 1.5vw, 0.95rem)",
                fontWeight: 400,
                letterSpacing: "0.3px",
                maxWidth: "650px",
                lineHeight: 1.5,
              }}
            >
              <span className="fw-bold">S</span>ystem for{" "}
              <span className="fw-bold">E</span>fficient{" "}
              <span className="fw-bold">T</span>rain Management &{" "}
              <span className="fw-bold">U</span>tility Dashboard
            </div>

            {/* Bottom glass panel */}
          </div>
        </div>
      </section>

      {/* ================= NAVIGATION SECTION ================= */}
      <section className=" px-3 px-md-4 py-2">
        <div className="">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-2 p-md-3">
              <div className="d-flex justify-content-center">
                <HomeNavBar />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================= PROJECTS SECTION ================= */}
      <section className=" px-3 px-md-4 py-4">
        <div className="">
          {/* Section heading */}
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div>
              <h5 className="fw-bold mb-1 text-dark">Other Projects</h5>

              <p className="text-muted small mb-0">
                Explore railway management and utility applications
              </p>
            </div>

            <div
              className="bg-primary rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "42px",
                height: "42px",
              }}
            >
              <span className="text-white fw-bold">RS</span>
            </div>
          </div>

          {/* Project cards */}
          <div className="card border-0 shadow-sm">
            <div className="card-body p-2 p-md-3">
              <div className="row g-3">
                <HomeSuggestion />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================= FOOTER ================= */}
      <footer className=" border-top mt-3">
        <div className=" py-3">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
            <small className="text-muted">Rail-Setu Dashboard</small>

            <small className="text-muted">
              Railway Operations & Utility Management
            </small>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
